import React, { useState } from 'react';
import Select, { components } from 'react-select';
import DropDownIcon from '../../assets/drop_down_icon.png';
import DropUpIcon from '../../assets/drop_up_icon.png';
import FailIcon from '../../assets/fail_icon.png';
import MessageSuccess from '../Messages/Success/index';
import DropLeftIcon from '../../assets/drop_left_icon.png';
import DropRightIcon from '../../assets/drop_right_icon.png';

import {
    GlobalContainer,
    ContentContainer,
    SelectContainer,
    ContentContainer1,
    ContentContainer2,
    ContentContainer4,
    ContentContainer11,
    Text,
    Title,
    TitleContainer,
    ContentContainerButtons,
    ExplanatoryText,
    SelectPagesContainer,
    PaginationContainer
} from './styles';
import ModalConfirm from '../Modal/Confirm/index';
import ModalWarn from '../Modal/Warn/index';
import { cpfMask } from '../../utils';

export default function UnitMigration(props) {
    const [ destinationUnitCode, setDestinationUnitCode ] = useState();
    const [ destinationUnitName, setDestinationUnitName ] = useState();
    const [ showErroDestinationUnitCodeField, setShowErroDestinationUnitCodeField ] = useState(false);
    const [rangePagesOptions] = useState([
        { value: "10", label: "10" },
        { value: "20", label: "20" },
        { value: "30", label: "30" },
    ]);
    const SelecPageStyles = {
        control: (defaultStyles, state) => ({
            ...defaultStyles,
            borderWidth: 0,
            borderColor: state.isFocused ? '#E60000' : '#888',
            '&:hover': {
                backgroundColor: '#C5D4EB',
            },
            marginTop: 15,
        }),
    }

    // ESTILIZACAO PARA O SELECT ======================================================
    const SelecStyles = {
        placeholder: (defaultStyles) => ({
            ...defaultStyles,
            fontSize: 13.5,
            fontWeight: 355,
            marginLeft: 7,
            color: "gray",
            fontStyle: 'italic',
        }),
    }
    const DropdownIndicator = (props) => {
        return (
            <components.DropdownIndicator {...props}>
                {props.selectProps.menuIsOpen 
                    ? <img src={DropUpIcon} alt="upicon" />
                    : <img src={DropDownIcon} alt="downicon"/>
                }
            </components.DropdownIndicator>
        );
    }; 
    const IndicatorSeparator = ({ innerProps }) => {
        return <span style={{}} {...innerProps} />;
    };

    // ================================================================================

    return (
        <>
                <>
                    <ModalConfirm 
                        id="modaluserMigrationConfirm"
                        appear={props.modalConfirmVisible}
                        title={"Atenção"}
                        text={props.messageModalConfirmVisible.replace('n_unidade_origem', props.originalUnit.unitName).replace('n_unidade_destino', destinationUnitName)}
                        textButton1={"Não"}
                        textButton2={"Sim"}
                        actionButton1={() => props.setModalConfirmVisible(false)}
                        actionButton2={() => props.onSubmitMigration(destinationUnitCode)} 
                    />
                    <ModalWarn
                        id="modalError"
                        appear={props.modalError}
                        text = {props.messageError}
                        textButton2='Ok'
                        actionButton2={() => {
                            props.setModalError(false);
                            props.setModalConfirmVisible(false);
                        }}
                    />

                    <ModalWarn
                        id="modalWarn"
                        appear={!((props.searchResult && props.searchResult.length) || (props.searchResultAttendant && props.searchResultAttendant.length)) && !(props.loadingRegionalManager || props.loadingAttendant)}
                        text = {props.messageModalWarn.replace('n_unidade_origem', props.originalUnit.unitName)}
                        textButton2='Ok'
                        actionButton2={() => {
                            props.history.push(props.buttonCancelRoute, props.originalUnit)
                        }}
                    />

                    <GlobalContainer>
                        {props.migrated && <MessageSuccess text={props.successMsg}/>}
                        <ContentContainer>
                            <ContentContainer1>
                                <TitleContainer>
                                    <Title> {props.pageTitle} </Title>
                                </TitleContainer>
                                <ContentContainer11>
                                    <ExplanatoryText> Esta funcionalidade permite transferir, de forma prática e segura, todos os Gestores Regionais (GR) e Atendentes de uma unidade de origem para uma unidade de destino, garantindo a integridade dos vínculos. </ExplanatoryText>
                                </ContentContainer11>
                                <ContentContainer11>
                                    <label htmlFor="unitName">Unidade de origem</label>
                                    <Text> {props.originalUnit.unitName} </Text>
                                </ContentContainer11>
                                <ContentContainer11>
                                    <SelectContainer>
                                        <label>Escolha a unidade para a qual deseja migrar</label>
                                        <Select
                                            isDisabled={false}
                                            onChange={(value) => {
                                                setDestinationUnitCode(value.value);
                                                setDestinationUnitName(value.label);
                                                if (value) {
                                                    setShowErroDestinationUnitCodeField(false); //Limpa erro
                                                }
                                            }}
                                            options={props.unidadeOptions}
                                            placeholder="Selecione a unidade"
                                            styles={SelecStyles}
                                            components={
                                                {
                                                    DropdownIndicator,
                                                    IndicatorSeparator
                                                }
                                            }
                                        />
                                        {showErroDestinationUnitCodeField &&
                                        <span className="feedback danger" role="alert" id="cpfoperator">
                                            <i className="fas fa-times-circle" aria-hidden="true">
                                                <img
                                                    src={FailIcon}
                                                    style={{ paddingBottom: '5px' }}
                                                    alt="failicon"
                                                />
                                            </i>
                                            Este campo é obrigatório.
                                        </span>}
                                    </SelectContainer>                                                    
                                </ContentContainer11>

                                <ContentContainer4>
                                    <label>{props.tableResultListTitle}</label>
                                    {!!(!(props.searchResult && props.searchResult.length)) && 
                                        <div style={{'marginTop': '10px'}}>
                                            <label style={{'color': 'red'}}>Não há gestores vinculados a esta unidade de origem.</label>
                                        </div>
                                    }
                                    {!!(props.searchResult && props.searchResult.length) && <>
                                        
                                        <div className="br-table" data-search="data-search" data-selection="data-selection">
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th scope="col0" style={{ 'color': '#1351B4' }}></th>
                                                        <th scope="col1" style={{ 'color': '#1351B4' }}> Nome completo </th>
                                                        <th scope="col2" style={{ 'color': '#1351B4' }}> CPF </th>
                                                        <th scope="col99" style={{ 'color': '#1351B4' }}></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {props.searchResult.map(result => (
                                                        <tr key={result.ID_USUARIO_ORGAO}>
                                                            <td> </td>
                                                            <td style={{ 'max-width': '133px' }}> {result.NOME_USUARIO} </td>
                                                            <td> { cpfMask(result.CPF_USUARIO) }</td>
                                                            <td> </td>
                                                        </tr>
                                                    )
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>

                                        <PaginationContainer>
                                            <nav className="br-pagination" aria-label="Paginação de resultados" data-total="50" data-current="1" data-per-page="20">
                                                <div className="pagination-per-page">
                                                    <label style={{ "fontWeight": "normal", "marginRight": "15px" }}> Exibir </label>
                                                    <SelectPagesContainer>
                                                        <Select
                                                            options={rangePagesOptions}
                                                            defaultValue={{ value: "10", label: "10" }}
                                                            value={props.rangePages}
                                                            onChange={value => {
                                                                props.setRangePages(value)
                                                                props.onChangePaginationConfigRegionalManager(value, props.page, true)
                                                            }}
                                                            styles={SelecPageStyles}
                                                            theme={theme => ({
                                                                ...theme,
                                                                borderRadius: 6,
                                                                colors: {
                                                                    ...theme.colors,
                                                                    primary25: '#CCCCCC',
                                                                    primary: '#1351B4'
                                                                },
                                                            })}
                                                            components={
                                                                {
                                                                    DropdownIndicator,
                                                                    IndicatorSeparator
                                                                }
                                                            }
                                                        />
                                                    </SelectPagesContainer>
                                                </div>

                                                <span className="br-divider d-none d-sm-block mx-3"></span>

                                                <div className="pagination-information d-none d-sm-flex">
                                                    <span className="current"> {1 + ((Number(props.page.value) - 1) * Number(props.rangePages.value))} </span>&ndash;<span className="per-page"> {Number(props.page.value) * Number(props.rangePages.value)} </span>&nbsp;de&nbsp;<span className="total"> {props.totalFilter} </span>&nbsp;itens
                                                </div>
                                                <div className="pagination-go-to-page d-none d-sm-flex ml-auto">
                                                    <label style={{ "fontWeight": "normal", "marginRight": "15px" }}> Página </label>
                                                    <SelectPagesContainer>
                                                        <Select
                                                            options={props.pageOptions}
                                                            defaultValue={{ value: "1", label: "1" }}
                                                            value={props.page}
                                                            onChange={value => {
                                                                props.setPage(value)
                                                                props.onChangePaginationConfigRegionalManager(props.rangePages, value, false)
                                                            }}
                                                            styles={SelecPageStyles}
                                                            theme={theme => ({
                                                                ...theme,
                                                                borderRadius: 6,
                                                                colors: {
                                                                    ...theme.colors,
                                                                    primary25: '#CCCCCC',
                                                                    primary: '#1351B4'
                                                                },
                                                            })}
                                                            components={
                                                                {
                                                                    DropdownIndicator,
                                                                    IndicatorSeparator
                                                                }
                                                            }
                                                        />
                                                    </SelectPagesContainer>
                                                </div>

                                                <span className="br-divider d-none d-sm-block mx-3"></span>

                                                <div className="pagination-arrows ml-auto ml-sm-0">
                                                    <button className="br-button circle" type="button" aria-label="Voltar página"
                                                        style={{
                                                            'opacity': Number(props.page.value) > 1 ? '' : '0.4',
                                                            'pointerEvents': Number(props.page.value) > 1 ? '' : 'none'
                                                        }}
                                                        onClick={() => {
                                                            const new_page = {
                                                                value: String(Number(props.page.value) - 1),
                                                                label: String(Number(props.page.value) - 1)
                                                            }
                                                            props.setPage(new_page)
                                                            props.onChangePaginationConfigRegionalManager(props.rangePages, new_page, false)
                                                        }}
                                                    >
                                                        <i className="fas fa-angle-left" aria-hidden="true">
                                                            <img
                                                                src={DropLeftIcon}
                                                                alt="leftIcon"
                                                                style={{ "marginBottom": "6px" }}
                                                            />
                                                        </i>
                                                    </button>
                                                    <button className="br-button circle" type="button" aria-label="Avançar página"
                                                        style={{
                                                            'opacity': Number(props.page.value) < (Math.ceil(Number(props.totalFilter) / Number(props.rangePages.value))) ? '' : '0.4',
                                                            'pointerEvents': Number(props.page.value) < (Math.ceil(Number(props.totalFilter) / Number(props.rangePages.value))) ? '' : 'none'
                                                        }}
                                                        onClick={() => {
                                                            const new_page = {
                                                                value: String(Number(props.page.value) + 1),
                                                                label: String(Number(props.page.value) + 1)
                                                            }
                                                            props.setPage(new_page)
                                                            props.onChangePaginationConfigRegionalManager(props.rangePages, new_page, false)
                                                        }}
                                                    >
                                                        <i className="fas fa-angle-right" aria-hidden="true">
                                                            <img
                                                                src={DropRightIcon}
                                                                alt="rightIcon"
                                                                style={{ "marginBottom": "6px" }}
                                                            />
                                                        </i>
                                                    </button>
                                                </div>
                                            </nav>
                                        </PaginationContainer>
                                    </>}
                                </ContentContainer4>
                                <ContentContainer4>
                                    <label>{props.tableResultListTitleAttendant}</label>
                                    {!!(!(props.searchResultAttendant && props.searchResultAttendant.length)) &&
                                        <div style={{'marginTop': '10px'}}>
                                            <label style={{'color': 'red'}}>Não há atendentes vinculados a esta unidade de origem.</label>
                                        </div>
                                    }
                                    {!!(props.searchResultAttendant && props.searchResultAttendant.length) && <>
                                        <div className="br-table" data-search="data-search" data-selection="data-selection">
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th scope="col0" style={{ 'color': '#1351B4' }}></th>
                                                        <th scope="col1" style={{ 'color': '#1351B4' }}> Nome completo </th>
                                                        <th scope="col2" style={{ 'color': '#1351B4' }}> CPF </th>
                                                        <th scope="col99" style={{ 'color': '#1351B4' }}></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {props.searchResultAttendant.map(result => (
                                                        <tr key={result.ID_USUARIO_ORGAO}>
                                                            <td> </td>
                                                            <td style={{ 'max-width': '133px' }}> {result.NOME_USUARIO} </td>
                                                            <td> { cpfMask(result.CPF_USUARIO) }</td>
                                                            <td> </td>
                                                        </tr>
                                                    )
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>

                                        <PaginationContainer>
                                            <nav className="br-pagination" aria-label="Paginação de resultados" data-total="50" data-current="1" data-per-page="20">
                                                <div className="pagination-per-page">
                                                    <label style={{ "fontWeight": "normal", "marginRight": "15px" }}> Exibir </label>
                                                    <SelectPagesContainer>
                                                        <Select
                                                            options={rangePagesOptions}
                                                            defaultValue={{ value: "10", label: "10" }}
                                                            value={props.rangePagesAttendant}
                                                            onChange={value => {
                                                                props.setRangePagesAttendant(value)
                                                                props.onChangePaginationConfigAttendant(value, props.pageAttendant, true)
                                                            }}
                                                            styles={SelecPageStyles}
                                                            theme={theme => ({
                                                                ...theme,
                                                                borderRadius: 6,
                                                                colors: {
                                                                    ...theme.colors,
                                                                    primary25: '#CCCCCC',
                                                                    primary: '#1351B4'
                                                                },
                                                            })}
                                                            components={
                                                                {
                                                                    DropdownIndicator,
                                                                    IndicatorSeparator
                                                                }
                                                            }
                                                        />
                                                    </SelectPagesContainer>
                                                </div>

                                                <span className="br-divider d-none d-sm-block mx-3"></span>

                                                <div className="pagination-information d-none d-sm-flex">
                                                    <span className="current"> {1 + ((Number(props.pageAttendant.value) - 1) * Number(props.rangePagesAttendant.value))} </span>&ndash;<span className="per-page"> {Number(props.pageAttendant.value) * Number(props.rangePagesAttendant.value)} </span>&nbsp;de&nbsp;<span className="total"> {props.totalFilterAttendant} </span>&nbsp;itens
                                                </div>
                                                <div className="pagination-go-to-page d-none d-sm-flex ml-auto">
                                                    <label style={{ "fontWeight": "normal", "marginRight": "15px" }}> Página </label>
                                                    <SelectPagesContainer>
                                                        <Select
                                                            options={props.pageOptionsAttendant}
                                                            defaultValue={{ value: "1", label: "1" }}
                                                            value={props.pageAttendant}
                                                            onChange={value => {
                                                                props.setPageAttendant(value)
                                                                props.onChangePaginationConfigAttendant(props.rangePagesAttendant, value, false)
                                                            }}
                                                            styles={SelecPageStyles}
                                                            theme={theme => ({
                                                                ...theme,
                                                                borderRadius: 6,
                                                                colors: {
                                                                    ...theme.colors,
                                                                    primary25: '#CCCCCC',
                                                                    primary: '#1351B4'
                                                                },
                                                            })}
                                                            components={
                                                                {
                                                                    DropdownIndicator,
                                                                    IndicatorSeparator
                                                                }
                                                            }
                                                        />
                                                    </SelectPagesContainer>
                                                </div>

                                                <span className="br-divider d-none d-sm-block mx-3"></span>

                                                <div className="pagination-arrows ml-auto ml-sm-0">
                                                    <button className="br-button circle" type="button" aria-label="Voltar página"
                                                        style={{
                                                            'opacity': Number(props.pageAttendant.value) > 1 ? '' : '0.4',
                                                            'pointerEvents': Number(props.pageAttendant.value) > 1 ? '' : 'none'
                                                        }}
                                                        onClick={() => {
                                                            const new_page = {
                                                                value: String(Number(props.pageAttendant.value) - 1),
                                                                label: String(Number(props.pageAttendant.value) - 1)
                                                            }
                                                            props.setPageAttendant(new_page)
                                                            props.onChangePaginationConfigAttendant(props.rangePagesAttendant, new_page, false)
                                                        }}
                                                    >
                                                        <i className="fas fa-angle-left" aria-hidden="true">
                                                            <img
                                                                src={DropLeftIcon}
                                                                alt="leftIcon"
                                                                style={{ "marginBottom": "6px" }}
                                                            />
                                                        </i>
                                                    </button>
                                                    <button className="br-button circle" type="button" aria-label="Avançar página"
                                                        style={{
                                                            'opacity': Number(props.pageAttendant.value) < (Math.ceil(Number(props.totalFilterAttendant) / Number(props.rangePagesAttendant.value))) ? '' : '0.4',
                                                            'pointerEvents': Number(props.pageAttendant.value) < (Math.ceil(Number(props.totalFilterAttendant) / Number(props.rangePagesAttendant.value))) ? '' : 'none'
                                                        }}
                                                        onClick={() => {
                                                            const new_page = {
                                                                value: String(Number(props.pageAttendant.value) + 1),
                                                                label: String(Number(props.pageAttendant.value) + 1)
                                                            }
                                                            props.setPageAttendant(new_page)
                                                            props.onChangePaginationConfigAttendant(props.rangePagesAttendant, new_page, false)
                                                        }}
                                                    >
                                                        <i className="fas fa-angle-right" aria-hidden="true">
                                                            <img
                                                                src={DropRightIcon}
                                                                alt="rightIcon"
                                                                style={{ "marginBottom": "6px" }}
                                                            />
                                                        </i>
                                                    </button>
                                                </div>
                                            </nav>
                                        </PaginationContainer>
                                    </>}
                                </ContentContainer4>    

                            </ContentContainer1>                                
                        </ContentContainer>

                        <ContentContainer>
                            <ContentContainer1>

                            </ContentContainer1>

                            <ContentContainer2>
                                <ContentContainerButtons>
                                    {!props.migrated &&
                                        <>
                                            <button className="br-button" type="button"
                                                onClick={() => props.history.push(props.buttonCancelRoute, props.originalUnit)}>
                                                Voltar
                                            </button>
                                        </>
                                    }
                                    
                                    {props.onSubmitMigration && (((props.searchResult && props.searchResult.length > 0) || (props.searchResultAttendant && props.searchResultAttendant.length > 0))) &&
                                        <>
                                            {!props.migrated ?
                                                <>
                                                    {!props.loading ?
                                                        <button className="br-button primary" type="button"
                                                                onClick={() => {
                                                                    if (destinationUnitCode) {
                                                                        props.setModalConfirmVisible(true)
                                                                    } else {
                                                                        setShowErroDestinationUnitCodeField(true);
                                                                    }
                                                                    }}>
                                                            Migrar GR's e Atendentes
                                                        </button>
                                                    :
                                                        <button className="br-button primary loading" type="button">
                                                            Migrar GR's e Atendentes
                                                        </button>
                                                    }
                                                </>
                                            :
                                                <button className="br-button secondary" type="button"
                                                    onClick={() => props.history.push(props.buttonCancelRoute, props.originalUnit)}>
                                                    Voltar
                                                </button>
                                            }
                                        </>
                                    }
                                </ContentContainerButtons>
                            </ContentContainer2>
                        </ContentContainer>
                    </GlobalContainer>
                </>            
        </>
    );
}